const initStart = new Date()

const startReducer = (state = initStart, action) => {
  switch (action.type) {
  case 'SETSTART':
    return action.start
  default:
    return state
  }
}

export const defineStart = (start) => {
  return {
    type: 'SETSTART',
    start
  }
}

export const setStart = (start) => {
  return async (dispatch) => {
    dispatch(defineStart(start))
  }
}

export default startReducer